import { useMutation } from "react-query";
import {
  triggerEnvelops, requestReportQc, requestHotelQc
} from "../api/qcApi";

const useTriggerEnvelope = (options = {}) => useMutation(triggerEnvelops, options);

const useRequestReportQc = (options = {}) => useMutation(requestReportQc, options);

const useRequestHotelQc = (options = {}) => useMutation(requestHotelQc, options);

export { useTriggerEnvelope, useRequestReportQc, useRequestHotelQc };
